import {Component , Vue} from "vue-property-decorator";
import {UserServices} from "../../services";
import {IQRCode , QrCode} from "../../models/qr-code/qr-code";
import {IUserInfoModel , UserInfoModel} from "../../models/user/user-info.model";
import UserUri from "../../common/uri/user-uri.constants";

@Component({
	name: "QrCodeComponent",
	template: require("./template.html")
})

export default class QrCodeComponent extends Vue {
	public visible: boolean = false;
	public userService: UserServices = new UserServices();
	public userQRCode: IQRCode = new QrCode({CodeBase64: '', ExpiredSeconds: 0, QRCodeUrl: ''});
	public isLoading: boolean = false;
	public isLogin: boolean = false;
	public error: string = null;
	public userInfo: IUserInfoModel = new UserInfoModel({
		Email: '',
		Name: ''
	});
	public password: string = '';
	
	get CodeBase64() {
		if (this.userQRCode.CodeBase64) {
			return `data:image/png;base64,${this.userQRCode.CodeBase64}`;
		}
		return null;
	}
	
	get QRCodeUrl() {
		if (this.userQRCode.checkExpired()){
			return '';
		}
		return this.userQRCode.QRCodeUrl || '';
	}
	get coTitle() {
		if (this.QRCodeUrl) {
			return this.$t('ACTIVE_DEVICE_BY_SCAN_QRCODE').toString();
		} else {
			return this.$t('PLEASELOGIN').toString();
		}
	}
	
	handleSubmit() {
		// TODO waiting API.
		this.generateQRCode();
	}
	
	handleSend() {
		this.isLoading = true;
		this.userService.post({Email: this.userInfo.Email, ExpiredAt: this.userQRCode.ExpiredAt, QRCodeUrl: this.userQRCode.QRCodeUrl }, UserUri.sendQRCode)
			.then((response: any) => {
				this.isLoading = false;
			}).catch((error: any) => {
			this.isLoading = false;
		})
	}
	
	handleClose() {
		this.visible = false;
		this.password = '';
		this.userQRCode.QRCodeUrl = '';
		this.error = null;
	}
	
	generateQRCode() {
		this.isLoading = true;
		this.userService.post({Password: this.password}, UserUri.qrCode)
			.then((response: any) => {
				if (response.hasOwnProperty('msg') && response.hasOwnProperty('code')) {
					return Promise.reject(response);
				}
				if (response.data) {
					this.userQRCode = new QrCode(response.data);
				}
				this.isLoading = false;
				this.error = null;
			}).catch((error: any) => {
				if (error.hasOwnProperty('msg')) {
					this.error = error.msg;
				}
			this.isLoading = false;
		});
	}
}
